import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { REQUEST_REPORT_ACTION, requestReport } from '~/actions';
import { useIsError, useIsSuccess, useLoading } from '~/hooks';

interface IRequestReportForm {
  email: string;
  ranges: string;
  notes: string;
}

export const useRequestReport = () => {
  const dispatch = useDispatch();

  const controller = useForm<IRequestReportForm>({
    defaultValues: {
      email: '',
      ranges: '',
      notes: '',
    },
    mode: 'all',
  });

  const { isError } = useIsError([REQUEST_REPORT_ACTION]);
  const { isLoading } = useLoading([REQUEST_REPORT_ACTION]);
  const { isSuccess } = useIsSuccess([REQUEST_REPORT_ACTION]);

  const onSubmit = controller.handleSubmit((formData: IRequestReportForm) => {
    dispatch(requestReport({ payload: formData }));
  });

  return { controller, onSubmit, isError, isLoading, isSuccess };
};
